export interface PresetCriterion {
  id: string;
  selectedMin?: number;
  selectedMax?: number;
  timeValue?: string;
}

export interface PresetSort {
  id: string;
  option?: string;
  asc: boolean;
}

export interface PresetStrategy {
  id: string;
  name: string;
  criteria: PresetCriterion[];
  sort?: PresetSort;
}

// Preset strategies for the "Preset strategies" section of the saved-strategy
// pulldown. Adding/editing a preset is purely a data change here - no UI code
// changes required.
export const PRESET_STRATEGIES: PresetStrategy[] = [
  {
    id: 'top-performers-1y',
    name: 'Top Performers 1Y',
    criteria: [
      { id: 'PV-70_5d' },
      { id: 'PV-70_52wk' },
      { id: 'PV-70_ytd' },
    ],
    sort: { id: 'PV-70_52wk', option: '52wk', asc: false },
  },
  {
    id: 'top-rated',
    name: 'Top Rated',
    criteria: [
      { id: 'CSC-10', selectedMin: 8 },
      { id: 'CSC-70' },
      { id: 'CSC-80' },
      { id: 'CSC-90' },
      { id: 'CSC-100' },
      { id: 'CSC-110' },
    ],
    sort: { id: 'CSC-10', asc: false },
  },
  {
    id: 'worst-rated',
    name: 'Worst Rated',
    criteria: [
      { id: 'CSC-10', selectedMin: 1, selectedMax: 3 },
      { id: 'CSC-70' },
      { id: 'CSC-80' },
      { id: 'CSC-90' },
      { id: 'CSC-100' },
      { id: 'CSC-110' },
    ],
    sort: { id: 'CSC-10', asc: true },
  },
  {
    id: 'top-dividends',
    name: 'Top Dividends',
    criteria: [
      { id: 'DIV-10', selectedMin: 2 },
      { id: 'GR-30', selectedMin: 5, timeValue: '5y' },
    ],
    sort: { id: 'DIV-10', asc: false },
  },
  {
    id: 'revenue-earnings-leaders',
    name: 'Revenue & Earnings Leaders',
    criteria: [
      { id: 'GR-20', selectedMin: 1 },
      { id: 'GR-10', selectedMin: 1, timeValue: 'yoy' },
    ],
    sort: { id: 'GR-10', option: 'yoy', asc: false },
  },
  {
    id: 'value-stocks',
    name: 'Value Stocks',
    criteria: [
      { id: 'VAL-10', selectedMin: 1, selectedMax: 20 },
      { id: 'VAL-40', selectedMin: 0, selectedMax: 3 },
      { id: 'PROF-20', selectedMin: 0.1 },
      { id: 'MGMT-10', selectedMin: 0.1 },
      { id: 'FIN-80', selectedMin: 0 },
      { id: 'SHR-10', selectedMin: 5000 },
    ],
    sort: { id: 'VAL-10', asc: true },
  },
  {
    id: 'upside-momentum',
    name: 'Upside Momentum',
    criteria: [
      { id: 'TECH-O-10', selectedMin: 55, selectedMax: 70 },
      { id: 'TECH-T-10' },
      { id: 'PP-60', selectedMin: 0, selectedMax: 25 },
      { id: 'SHR-10', selectedMin: 1000 },
    ],
    sort: { id: 'SHR-10', asc: false },
  },
  {
    id: 'downside-momentum',
    name: 'Downside Momentum',
    criteria: [
      { id: 'TECH-O-10', selectedMin: 30, selectedMax: 50 },
      { id: 'TECH-T-30' },
      { id: 'SHR-10', selectedMin: 1000 },
    ],
    sort: { id: 'SHR-10', asc: false },
  },
  {
    id: 'undervalued-dividend-players',
    name: 'Undervalued Dividend Players',
    criteria: [
      { id: 'DIV-10', selectedMin: 2, selectedMax: 6 },
      { id: 'VAL-10', selectedMin: 0, selectedMax: 20 },
      { id: 'VAL-40', selectedMin: 0, selectedMax: 3 },
      { id: 'GR-30', selectedMin: 0, timeValue: '5y' },
      { id: 'FIN-80', selectedMin: 0, selectedMax: 100 },
      { id: 'SHR-10', selectedMin: 0, selectedMax: 1000 },
    ],
    sort: { id: 'ticker', asc: true },
  },
];